import api from '../api/config';

/**
 * Per-file annotations API (storage.file_annotation): one row per (patient
 * file, kind), payload shape owned by the kind. Current kinds are the CBCT
 * viewer's persisted sections: cbct.arch / cbct.tmj / cbct.measurements /
 * cbct.annotations.
 */

export interface FileAnnotationDto {
    kind: string;
    payload: unknown;
    schemaVersion: number;
    source: string;
    createdBy: string | null;
    updatedAt: string;
}

export const fetchFileAnnotations = async (
    patientId: string,
    patientFileId: string
): Promise<FileAnnotationDto[]> => {
    const response = await api.get<{ success: boolean; data: FileAnnotationDto[] }>(
        `/patients/${patientId}/cloud-files/${patientFileId}/annotations`
    );
    return response.data.data;
};

export const putFileAnnotation = async (
    patientId: string,
    patientFileId: string,
    kind: string,
    payload: unknown
): Promise<void> => {
    await api.put(`/patients/${patientId}/cloud-files/${patientFileId}/annotations/${kind}`, {
        payload
    });
};
